export default {"src":"/_next/static/media/mosnter_pic_icon.a5d7dfe6.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};